import React, { useEffect, useState } from "react";
import { Progress, Text } from "@mantine/core";
import moment from "moment";
import { useServerApi } from "../../hooks/userServerApi";
import QuizStatusBadge from "./QuizStatusBadge";

export const QuizPassRateCell = ({ quizId }) => {
  const [api] = useServerApi();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let active = true;
    api.Quiz.getStatistics(quizId).then((res) => {
      if (active) setStats(res?.data ?? null);
    });
    return () => {
      active = false;
    };
  }, [quizId]);

  if (!stats) return <Text size="sm">--</Text>;
  const passRate = stats.total > 0 ? Math.round((stats.passed / stats.total) * 100) : 0;

  return (
    <>
      <Text size="sm">
        {passRate}% ({stats.passed ?? 0} passed)
      </Text>
      <Progress value={passRate} size="sm" mt={4} />
    </>
  );
};

export const QuizParticipantsCell = ({ quizId }) => {
  const [api] = useServerApi();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let active = true;
    api.Quiz.getStatistics(quizId).then((res) => {
      if (active) setStats(res?.data ?? null);
    });
    return () => {
      active = false;
    };
  }, [quizId]);

  if (!stats) return <Text size="sm">--</Text>;
  return (
    <Text size="sm">
      {stats.completed ?? 0} / {stats.total ?? 0} completed
    </Text>
  );
};

export const quizTableColumns = () => [
  {
    field: "title",
    headerName: "Quiz Title",
    sortable: true,
    width: 360,
    cellRender: (col, data) => (
      <>
        <Text weight={500}>{data.title}</Text>
        <Text size="xs" color="dimmed">
          {data.code}
        </Text>
      </>
    ),
  },
  {
    field: "status",
    headerName: "Status",
    sortable: true,
    cellRender: (col, data) => <QuizStatusBadge status={data.status} />,
    filterable: true,
    filter: {
      apiEntity: "quiz",
      field: "status",
      label: "Quiz Status",
      width: 250,
      height: 300,
    },
  },
  {
    field: "participants",
    headerName: "Participants",
    cellRender: (col, data) => <QuizParticipantsCell quizId={data._id} />,
  },
  {
    field: "deadline",
    headerName: "Deadline",
    sortable: true,
    cellRender: (col, data) =>
      data.deadline ? moment(data.deadline).format("YYYY-MM-DD") : "--",
  },
  {
    field: "passRate",
    headerName: "Pass Rate",
    cellRender: (col, data) => <QuizPassRateCell quizId={data._id} />,
  },
];
